import iFrameResize from 'iframe-resizer'

export default function iFrameResizeEnable() {
  try {
    let iframes = document.getElementsByClassName('iframe-resize')
    if (iframes[0]) {
      const code = "iFrameResize({log:false, inPageLinks:false, checkOrigin:false, autoResize:true, warningTimeout: 0});";
      const script = document.createElement("script");
      script.setAttribute("type", "text/javascript");
      script.setAttribute('charset', 'UTF-8');
      script.appendChild(document.createTextNode(code));
      document.body.appendChild(script);
      
      for (let i = 0; i < iframes.length; i++) {
          iframes[i].src = iframe[i].src;
      }
    } else {
        setTimeout(iFrameResizeEnable, 500)
    }
    
  } catch(error) {
    console.log('Iframe class not found on page.');
  }
}
